var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-div"},[_c('div',{staticClass:"main-chart"},[_c('canvas',{attrs:{"id":"live-stats-sub-chart-finance","width":"1"}})])])}]

export { render, staticRenderFns }